<template>
<div>
    <img src="../assets/img/denuncia_bg.jpg" class="login-background">
    <div class="container mt-4">
        <div class="d-flex justify-content-between header p-3 pl-5 pr-5">
            <img :src="logotipo">
            <!--<img src="../assets/img/logo_denuncia.png">-->

            <div class="align-self-center">
                <div class="text-center den-title">
                    <h1>{{view_nome.titulo_denuncia}}</h1>
                </div>
            </div>
        </div>

        <div class="content">
            <div class="container">
                <transition mode="out-in" name="leftIn">
                    <router-view></router-view>
                </transition>
            </div>
        </div>

        <div class="d-flex justify-content-center footer">
            <div class="d-flex align-items-center">
                Todos os direitos reservados © 2024.&nbsp;<a href="https://www.dad.eng.br" target="_blanck">DAD Tecnologia</a>
            </div>
        </div>

        <br>
    </div>
</div>
</template>

<script>
    export default {
        name: "Denuncia-online",
        computed: {
            logotipo() { 
                return this.$store.state.config.logotipo;
            },
            view_nome(){ 
                return this.$store.state.config_view_menu; 
            }
        }
    }
</script>

<style>
    @import url('https://fonts.googleapis.com/css?family=Bebas+Neue&display=swap');

    body {
        background: linear-gradient(135deg, rgb(204, 204, 204), rgb(179, 178, 178));
    }

    .content {
        background: linear-gradient(135deg, rgb(218, 218, 218, 0.7), rgb(255, 255, 255, 0.7));
        margin: 0;
        padding: 20px;
        border-radius: .25em;
    }

    .header, .footer {
        background: linear-gradient(135deg, rgb(148, 148, 148, 0.7), rgb(155, 155, 155, 0.7));
        border-radius: .25em;
    }

    .footer {
        height: 40px;
        font-size: 12px;
        color: white;
        border-radius: .25em;
    }

    .footer a {
        color: azure;
        font-weight: bold;
    }

    .footer a:hover {
        color: rgb(60, 128, 103)
    }

    .header img {
        height: 220px;
    }

    .den-title {
        font-family: 'Bebas Neue', cursive;
    }
    
    .login-background {
	height: auto !important; 
    }
</style>
